exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".imageLogo___Dip2n{max-width:91px;max-height:20px}.asDialogTitle___3905z{margin-bottom:-6px}", "", {"version":3,"sources":["/home/jenkins/agent/workspace/hpp-frontend_master/client/common/components/issuer-logo/index.css"],"names":[],"mappings":"AAAA,mBAAW,eAAe,eAAe,CAAC,uBAAe,kBAAkB,CAAC","file":"index.css","sourcesContent":[".imageLogo{max-width:91px;max-height:20px}.asDialogTitle{margin-bottom:-6px}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"imageLogo": "imageLogo___Dip2n",
	"asDialogTitle": "asDialogTitle___3905z"
};